import { useTracking } from "@similarweb/tracking-provider";

import {
    GaReconnectButton,
    GATriggerWithPropertyMapping,
    useActivationGaMappingDetailQuery,
} from "app/pages/activation";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { generateAutomationName } from "../../helpers/helpers";
import ConnectGAButton from "../Share/ConnectGAButton/ConnectGAButton";

interface IGAConnectContainerProps {
    activationId: string;
    isGaSource?: boolean;
}

export const GAConnectContainer = ({ activationId, isGaSource }: IGAConnectContainerProps) => {
    const { track } = useTracking();
    const { data, isLoading } = useActivationGaMappingDetailQuery(activationId, {
        shouldIgnoreResourceNotFoundError: true,
    });

    if (isLoading || (isGaSource && data?.state === "Active")) {
        return null;
    }

    if (data?.state === "Disabled") {
        return (
            <GaReconnectButton
                dataAutomation={generateAutomationName("report", ["header", "activate", "GA", "button"])}
                activationId={activationId}
                connectionId={data.connectionId}
                propertyId={data.propertyId}
                streamId={data.streamId}
            />
        );
    }

    const handleOpen = () => {
        track("Connect GA", "click", "Connect your website");
    };

    const handleClose = () => {
        // probably that should be enough to invalidate/refetch the related data only
        // keeping for now the same behavior as currently used
        proNavigator.reload();
    };

    return (
        <GATriggerWithPropertyMapping
            activationId={activationId}
            hasGaMapping={!!data}
            onOpen={handleOpen}
            onClose={handleClose}
        >
            {({ open, isLoading: isGAConnectionsListLoading }) => (
                <ConnectGAButton
                    isAvailable
                    isGAConnectionsListLoading={isGAConnectionsListLoading}
                    onClick={open}
                />
            )}
        </GATriggerWithPropertyMapping>
    );
};
